import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Marker';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5887 15.8872C15.741 13.5195 16.5 10.9009 16.5 9.54545C16.5 8.10393 16.1026 6.82869 15.3877 5.94593C14.7081 5.10691 13.6478 4.5 12 4.5C10.3522 4.5 9.29188 5.10691 8.61233 5.94593C7.89736 6.82869 7.5 8.10393 7.5 9.54545C7.5 10.9009 8.25897 13.5195 9.41125 15.8872C9.97503 17.0456 10.5845 18.0413 11.1563 18.722C11.4425 19.0626 11.6837 19.2815 11.8663 19.4054C11.9258 19.4457 11.97 19.47 12 19.4844C12.03 19.47 12.0742 19.4457 12.1337 19.4054C12.3163 19.2815 12.5575 19.0626 12.8437 18.722C13.4155 18.0413 14.025 17.0456 14.5887 15.8872ZM12 21C14.5 21 18 12.9345 18 9.54545C18 6.15643 16.1421 3 12 3C7.85786 3 6 6.15643 6 9.54545C6 12.9345 9.5 21 12 21Z" fill="currentColor"/>
  </svg>
`;

const MarkerIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5887 15.8872C15.741 13.5195 16.5 10.9009 16.5 9.54545C16.5 8.10393 16.1026 6.82869 15.3877 5.94593C14.7081 5.10691 13.6478 4.5 12 4.5C10.3522 4.5 9.29188 5.10691 8.61233 5.94593C7.89736 6.82869 7.5 8.10393 7.5 9.54545C7.5 10.9009 8.25897 13.5195 9.41125 15.8872C9.97503 17.0456 10.5845 18.0413 11.1563 18.722C11.4425 19.0626 11.6837 19.2815 11.8663 19.4054C11.9258 19.4457 11.97 19.47 12 19.4844C12.03 19.47 12.0742 19.4457 12.1337 19.4054C12.3163 19.2815 12.5575 19.0626 12.8437 18.722C13.4155 18.0413 14.025 17.0456 14.5887 15.8872ZM12 21C14.5 21 18 12.9345 18 9.54545C18 6.15643 16.1421 3 12 3C7.85786 3 6 6.15643 6 9.54545C6 12.9345 9.5 21 12 21Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: MarkerIcon,
  IconSvg: IconSvg
} as IconType;
